import React from 'react';

function Hero() {
  return (
    <section
      id="top"
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: '0 3.5rem',
        position: 'relative',
      }}
    >
      {/* Bootstrap container for responsive padding */}
      <div className="container-fluid px-0" style={{ maxWidth: 900 }}>

        <h1
          className="anim-fade-up delay-2"
          style={{
            fontFamily: "'Syne', sans-serif",
            fontSize: 'clamp(3.5rem, 8vw, 7rem)',
            fontWeight: 800,
            lineHeight: 1.0,
            letterSpacing: '-0.03em',
            background: 'linear-gradient(135deg, #7eb8ff 0%, #1a6cf5 40%, #a78bfa 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            marginBottom: '0.3rem',
          }}
        >
          Zachary Djerdjouri
        </h1>

        <h2
          className="anim-fade-up delay-3"
          style={{
            fontFamily: "'Syne', sans-serif",
            fontSize: 'clamp(1.5rem, 3.5vw, 2.8rem)',
            fontWeight: 600,
            color: 'var(--muted)',
            letterSpacing: '-0.02em',
            marginBottom: '1.5rem',
          }}
        >
          Creating for the web, apps, and everything in between.
        </h2>

        <p
          className="anim-fade-up delay-4"
          style={{ maxWidth: 560, color: 'var(--muted)', fontSize: '1.05rem', marginBottom: '2.5rem' }}
        >
          Full-stack developer & CS student at the University of Ottawa, currently building production software at{' '}
          <span style={{ color: 'var(--text)', fontWeight: 500 }}>Transport Canada</span>. <br></br>
          Passionate about clean code, great UX, and learning every day.
        </p>

        {/* Bootstrap d-flex for CTA row */}
        <div className="d-flex gap-3 flex-wrap anim-fade-up delay-5">
          <a href="#howIWork" className="btn-primary-custom">View my work ↓</a>
          <a href="#contact" className="btn-outline-custom">Get in touch</a>
          <a
            href="https://www.linkedin.com/in/zachary-djerdjouri-902142212/"
            target="_blank"
            rel="noreferrer"
            className="btn-outline-custom"
          >
            LinkedIn ↗
          </a>
        </div>
      </div>

      {/* Scroll hint */}
      <div
        style={{
          position: 'absolute',
          bottom: '2.5rem',
          left: '50%',
          transform: 'translateX(-50%)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 8,
          color: 'var(--muted)',
          fontSize: '0.72rem',
          letterSpacing: '0.12em',
          textTransform: 'uppercase',
          animation: 'bounce 2s infinite',
        }}
      >
        <span style={{ width: 1, height: 36, background: 'linear-gradient(to bottom, var(--blue-light), transparent)' }} />
        scroll
      </div>
    </section>
  );
}

export default Hero;
